import { request } from '@/lib/api'

/**
 * Коммерческое предложение (тикет #67, карточка — Quote.dc.html).
 *
 * Поля КП карточка читает механизмом списков; здесь — документ целиком со строками и
 * операции жизненного цикла. Порог согласования проверяется сервером **в момент отправки**
 * (`QuoteService.send`), а не флагом на документе: скидка, поднятая после согласования,
 * иначе ушла бы клиенту несогласованной. Поэтому отказ отправки — текст сервера, а не
 * вычисление на клиенте.
 */

export interface QuoteLine {
  id: string
  productId: string | null
  quantity: number
  unitPrice: number
  discountPercent: number
  vatRate: number
  lineTotal: number
}

export interface Quote {
  id: string
  number: string
  /** `draft` | `sent` | `accepted` | `rejected` | `expired`. */
  status: string
  dealId: string | null
  organizationId: string
  counterpartyId: string | null
  currency: string
  issuedOn: string | null
  validUntil: string | null
  subtotal: number
  discountTotal: number
  vatTotal: number
  total: number
  sentAt: string | null
  lines: QuoteLine[]
}

const BASE = '/sales/quotes'

export function fetchQuote(id: string, signal?: AbortSignal): Promise<Quote> {
  return request<Quote>(`${BASE}/${id}`, { signal })
}

/** С этого момента содержимое зафиксировано; при перейдённом пороге сервер откажет. */
export function sendQuote(id: string): Promise<Quote> {
  return request<Quote>(`${BASE}/${id}/send`, { method: 'POST' })
}

/** Клиент принял: счёт родится в биллинге асинхронно, этот вызов его не возвращает. */
export function acceptQuote(id: string): Promise<Quote> {
  return request<Quote>(`${BASE}/${id}/accept`, { method: 'POST' })
}

export function rejectQuote(id: string): Promise<Quote> {
  return request<Quote>(`${BASE}/${id}/reject`, { method: 'POST' })
}

/**
 * Сумма строки до скидки и без НДС — для столбца «цена × количество». Итоги не
 * пересчитываются: их отдаёт сервер, и второй расчёт рядом заставил бы выбирать, какому
 * верить.
 */
export function lineNet(line: QuoteLine): number {
  return Math.round(line.quantity * line.unitPrice * (1 - line.discountPercent / 100) * 100) / 100
}
